import { EnvironmentProviders, Provider, inject, provideAppInitializer } from '@angular/core';

import { Logger, WINDOW } from '@frontend/vanilla/core';

import { VIEW_TRANSITION_LOG_TAG as LOG_TAG } from '../view-transition.constants';
import { HistoryApiNativeTransitionDetectionStrategy } from './strategies/history-api-native-transition-detection.strategy';
import { NativeTransitionDetectionStrategy } from './strategies/model/native-transition-detection.strategy.model';
import { NavigationApiNativeTransitionDetectionStrategy } from './strategies/navigation-api-native-transition-detection.strategy';

export class NativeTransitionDetectionService {
    readonly #logger = inject(Logger);
    readonly #windowRef = inject(WINDOW);

    #strategy?: NativeTransitionDetectionStrategy;

    get strategy() {
        return this.#strategy;
    }

    init(): void {
        const isNavigationApiSupported = this.#windowRef.navigation;

        if (isNavigationApiSupported) {
            this.#logger.info(`${LOG_TAG} Using Navigation Api strategy for native transition detection`);

            this.#strategy = new NavigationApiNativeTransitionDetectionStrategy().init();
        } else {
            this.#logger.info(`${LOG_TAG} Using History Api strategy for native transition detection`);

            this.#strategy = new HistoryApiNativeTransitionDetectionStrategy().init();
        }
    }
}

export const provideNativeTransitionDetection = (): (EnvironmentProviders | Provider)[] => {
    return [NativeTransitionDetectionService, provideAppInitializer(nativeTransitionDetectionInitializer)];
};

const nativeTransitionDetectionInitializer = (): void => {
    inject(NativeTransitionDetectionService).init();
};
